import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const Footer = () => {
  return (
    <footer className="bg-white border-t hairline border-border">
      <div className="max-w-screen-xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Copyright */}
          <p className="text-sm text-muted-foreground">
            © 2026 Guzman Rodriguez Law. All rights reserved.
          </p>

          {/* Quick Links */}
          <div className="flex items-center gap-6">
            <Link href="/homepage" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Home
            </Link>
            <Link href="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              About
            </Link>
            <Link href="/services" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Services
            </Link>
            <Link href="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Contact
            </Link>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a
              href="mailto:contact@guzmanrodriguezlaw.com"
              className="text-muted-foreground hover:text-foreground transition-colors"
              aria-label="Email"
            >
              <Icon name="EnvelopeIcon" size={20} />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors"
              aria-label="LinkedIn"
            >
              <Icon name="LinkIcon" size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;